import { GoogleAnalyticsService } from 'app/services/analytics/google-analitics-service';
import { Component, OnInit } from '@angular/core';
import { get } from 'lodash';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from 'app/services/auth/auth.service';


@Component({
  standalone: false,
  selector: 'fuse-dialog-login',
  templateUrl: './dialog-login.component.html',
  styleUrls: ['./dialog-login.component.scss']
})
// tslint:disable-next-line:component-class-suffix
export class DialogLogin implements OnInit {

  public formGroup: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogLogin>,
    private toast: NotificationsService,
    private authService: AuthService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    this.formGroup = new UntypedFormGroup({
      'username': new UntypedFormControl('', [Validators.required]),
      'password': new UntypedFormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    this.googleAnalyticsService.pageEmitter('LoginPage');
  }

  onYesClick(): void {
    this.authService.login({
      username: this.formGroup.get('username').value,
      password: this.formGroup.get('password').value
    }).subscribe({
      next: (data) => {
        this.googleAnalyticsService.eventEmitter('LoginPage', 'Login Successfully');
        this.dialogRef.close(data);
      },
      error: (err) => {
        const errorMessage = get(err, 'error.message', '');
        if (errorMessage === 'USER_NOT_FOUND') {
          this.googleAnalyticsService.eventEmitter('LoginPage', 'Login Fault (user not found)');
          this.toast.error('Errore', 'Utente non trovato!');
        } else if (errorMessage === 'USER_DISABLED') {
          this.googleAnalyticsService.eventEmitter('LoginPage', 'Login Fault (user disabled)');
          this.toast.error('Errore', 'Utente Disabilitato!');
        } else if (errorMessage === 'WRONG_PASSWORD') {
          this.googleAnalyticsService.eventEmitter('LoginPage', 'Login Fault (wrong password)');
          this.toast.error('Errore', 'Password errata!');
        } else {
          this.googleAnalyticsService.eventEmitter('LoginPage', 'Login Fault (generic)');
          this.toast.error('Errore', 'Autenticazione Falita.');
        }
      }
    });
  }

  Registration(): void {
    this.dialogRef.close({ registration: true });
  }
  Forgot(): void {
    this.dialogRef.close({ forgot: true });
  }
}
